import { Box } from '@chakra-ui/react';
import React from 'react';
import { OnboardingFormModal } from '../OnboardingFormModal/OnboardingFormModal';

type OnboardingGuardProps = {
	isCampaignFieldsSet: boolean;
};

export const OnboardingGuard = ({
	isCampaignFieldsSet,
}: OnboardingGuardProps) => (
	<Box h={'100dvh'} background={'background'}>
		<OnboardingFormModal isOpen={!isCampaignFieldsSet} />
	</Box>
);
